import React, { useState } from 'react';
import { Office, OfficeCreate, officeApi } from '../services/api';
import './OfficeForm.css';

interface OfficeFormProps {
  office?: Office | null;
  onClose: () => void;
  onSubmit: () => void;
}

const OfficeForm: React.FC<OfficeFormProps> = ({ office, onClose, onSubmit }) => {
  const [formData, setFormData] = useState<OfficeCreate>({
    building: office?.building || '',
    floor: office?.floor || '',
    description: office?.description || '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (office) {
        await officeApi.update(office.id, formData);
      } else {
        await officeApi.create(formData);
      }
      onSubmit();
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to save office');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>{office ? 'Edit Office' : 'Add New Office'}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="building">Building</label>
            <input
              type="text"
              id="building"
              name="building"
              value={formData.building}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="floor">Floor</label>
            <input
              type="text"
              id="floor"
              name="floor"
              value={formData.floor}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
            />
          </div>

          {error && <div className="error">{error}</div>}

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : office ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OfficeForm;